/**
 * Route tree.
 *
 * One-to-one with the Next.js App Router pages it replaces:
 *   app/page.tsx          -> "/"
 *   app/dashboard/page    -> "/dashboard"
 *   app/purchase/page     -> "/purchase"
 *   app/r/[code]/page     -> "/r/:code"
 *
 * `RootLayout` carries what `app/layout.tsx` carried — the provider stack, the
 * navbar, the toaster — so a page component renders exactly the subtree it did
 * before.
 */
import { createBrowserRouter } from "react-router-dom";

import { ErrorBoundary } from "./ErrorBoundary";
import { routes } from "./hooks/useRoutes/useRoutes";
import DashboardPage from "./pages/DashboardPage";
import HomePage from "./pages/HomePage";
import PurchasePage from "./pages/PurchasePage";
import ReferralPage from "./pages/ReferralPage";
import { RootLayout } from "./RootLayout";

export const router = createBrowserRouter([
  {
    element: <RootLayout />,
    errorElement: <ErrorBoundary />,
    children: [
      { path: routes.home(), element: <HomePage /> },
      { path: routes.dashboard.index(), element: <DashboardPage /> },
      { path: routes.purchase.index(), element: <PurchasePage /> },
      { path: routes.referrals.pattern(), element: <ReferralPage /> },
    ],
  },
]);
